import React from 'react';
import {
  compose,
  branch,
  renderNothing,
} from 'recompose';
import SupportEmail, { supportEmailString } from '../Helpers/SupportEmail';
import config from '../../../config';
import { HTMLTrans } from '../Translations';

export const orderStatus = {
  PAYMENT_IN_PROGRESS: 'Payment In Progress',
  CANCELLED: 'Cancelled',
};

const supportEmail = <SupportEmail/>;
const supportEmailStr = supportEmailString();

const MessageBody = ({ status }) => {
  switch (status) {
    case orderStatus.CANCELLED:
      return (
        <HTMLTrans id="navbar.errorbox_cancelled_description" variables={{"supportEmail": supportEmailStr}}>
          <p className='mb-0'>Order cancelled due to payment related error.
          <br/>Please reorder or contact customer support via {supportEmail} with payment transaction details, in order for us to process this order.</p>
        </HTMLTrans>
      )
    case orderStatus.PAYMENT_IN_PROGRESS:
      return <p className='mb-0'><HTMLTrans id="navbar.errorbox_pendingpayment_description">This order is pending payment confirmation, please check back in 15 minutes.</HTMLTrans></p>;
    default:
      return null;
  }
};

const ErrorBox = (props) => {
  const {
    status,
  } = props;

  return (
      <div className='media bg-secondary-lighten-2 text-danger p-3 d-inline-block d-lg-flex text-center text-lg-left rounded'>
        <div className='align-self-start d-inline-block'>
          <img src={`${config.s3BucketUrl}/assets/general/info-icon-red.png`} className='img-fluid h-50 w-50'/>
        </div>
        <div className="media-body responsive-content-body">
          <MessageBody status={status}/>
        </div>
      </div>
  );
};

const noErrorFound = ({ status }) => (Object.values(orderStatus).indexOf(status) < 0);
const enhanceErrorBoxComp = compose(
  branch(
    noErrorFound,
    renderNothing,
  ),
);

export default enhanceErrorBoxComp(ErrorBox);
export const undecorated = ErrorBox;



// WEBPACK FOOTER //
// ./src/Common/ErrorBox/ErrorBox.js